import * as update from "immutability-helper";
import * as DTOS from "../FeralScan.dtos";
import {
    DashboardAction,
    SAVE_LOAD,
    SAVE_REQUEST
} from "../actions/dashboard.actions";


export type PreferenceState = {
    saving: boolean,
    preference: DTOS.UserPreference
}

const initialState: PreferenceState = {
    saving: true,
    preference: undefined
};

export default function preference(state: PreferenceState = initialState, action: DashboardAction) {
    switch (action.type) {
        case SAVE_REQUEST:
            return savingData(state, true);
        case SAVE_LOAD:
            return updateResults(state, action);
    }
    return state;
}

function savingData(state: PreferenceState, saving: boolean) {
    let newState: PreferenceState = update(state, {
        saving: { $set: saving }
    });
    return newState;
}

function updateResults(state: PreferenceState, action: DashboardAction) {
    var newState: PreferenceState = update(state, {
        preference: { $set: action.preference }
    });
    return savingData(newState, false);
}

